import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/sections/Hero";
import { Intro } from "./components/sections/Intro";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Challenges } from "./components/sections/Challenges";
import { Volumes } from "./components/sections/Volumes";
import { Resources } from "./components/sections/Resources";
import { Bonuses } from "./components/sections/Bonuses";
import { ValueStack } from "./components/sections/ValueStack";
import { SpecialOffer } from "./components/sections/SpecialOffer";
import { Decision } from "./components/sections/Decision";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-clip bg-paper font-sans text-ink antialiased" data-id="element-0" data-mp="3mlax56bfqdtg">
      <MetaPixel data-id="element-1" data-mp="3rcj8i7wbs999" />
      <Hero data-id="element-2" data-mp="3rbznujfaj6rj" />
      <main data-id="element-3" data-mp="3rdkhm6ts6loc">
        <Intro data-id="element-4" data-mp="3rcswxr1q28cu" />
        <BeforeAfter data-id="element-5" data-mp="3recd7hndojem" />
        <Challenges data-id="element-6" data-mp="5yh2n2cyzbp" />
        <Volumes data-id="element-7" data-mp="67znpl2q47d" />
        <Resources data-id="element-8" data-mp="4n4pyuukj8z" />
        <Bonuses data-id="element-9" data-mp="56n1goet9nj" />
        <ValueStack data-id="element-10" data-mp="7svdij4jt6t" />
        <SpecialOffer data-id="element-11" data-mp="2zld259q0hfbj" />
        <Decision data-id="element-12" data-mp="2zm4yimrfnh2v" />
        <Testimonials data-id="element-13" data-mp="2zmo3z3zwcd00" />
        <Author data-id="element-14" data-mp="2zn6cp03qwjot" />
        <FAQ data-id="element-15" data-mp="33mowttnqsqql" />
        <FinalCTA data-id="element-16" data-mp="33m5am0r27g6r" />
      </main>
      <Footer data-id="element-17" data-mp="33nggq77z9011" />
      <FloatingCTA data-id="element-18" data-mp="33mymth8sexwa" />
      <PurchasePopup data-id="element-19" data-mp="33oi1j3esp0vy" />
    </div>;
}